import { useEffect, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimesCircle, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { Axios } from "../../../API/Axios";
import { useLanguage } from "../../../Context/LanguageContext";
import "./PaymentVerify.css";

export default function PaymentVerify ()
{
    const { t } = useLanguage();
    const navigate = useNavigate();
    const [ searchParams ] = useSearchParams();

    const orderId = searchParams.get( "order_id" );
    const paymentId = searchParams.get( "id" ); // Moyasar بيرجعه تلقائيًا في الرابط

    const [ status, setStatus ] = useState( "verifying" ); // verifying | success | failed

    useEffect( () =>
    {
        if ( !orderId || !paymentId )
        {
            setStatus( "failed" );
            return;
        }

        Axios.post( "/payments/verify", { order_id: orderId, payment_id: paymentId } )
            .then( ( res ) =>
            {
                setStatus( res.data.success ? "success" : "failed" );
                setTimeout( () => navigate( `/orders/${ orderId }` ), 2500 );
            } )
            .catch( () => setStatus( "failed" ) );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [] );

    return (
        <div className="payment-verify-page">
            <div className="pv-card">
                { status === "verifying" && (
                    <>
                        <FontAwesomeIcon icon={ faSpinner } spin className="pv-icon pv-icon--pending" />
                        <h1>{ t( "checkout.verifyingPayment" ) }</h1>
                    </>
                ) }

                { status === "success" && (
                    <>
                        <FontAwesomeIcon icon={ faCheckCircle } className="pv-icon pv-icon--success" />
                        <h1>{ t( "checkout.paymentSuccess" ) }</h1>
                        <p>{ t( "checkout.redirecting" ) }</p>
                    </>
                ) }

                { status === "failed" && (
                    <>
                        <FontAwesomeIcon icon={ faTimesCircle } className="pv-icon pv-icon--failed" />
                        <h1>{ t( "checkout.paymentFailed" ) }</h1>
                        <Link to="/profile" className="pv-back-link">{ t( "checkout.backToCart" ) }</Link>
                    </>
                ) }
            </div>
        </div>
    );
}
